<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-show="isLoaded">
      <b-overlay :show="busy" rounded="sm">
        <b-form @submit="SubmitForm">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col">
                  <label>Wybrany młyn:</label>
                  <v-select label="name" :options="mills" v-model="form.millId" :reduce="(x) => x.id"
                    :disabled="true"></v-select>
                </div>
              </div>
            </div>
            <div class="col">
              <DisplayRecepies ref="recipe" @selectedRecepie="SetRecipe"></DisplayRecepies>
            </div>
          </div>
          <hr />

          <div v-if="isLoaded">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <h4>Produkty znajdujące się w kuwerturze</h4>
                  </div>
                  <div class="col-4">
                    <button type="button" class="btn btn-primary float-right"
                      @click="AddNextPositionToCouvertureGroupList">
                      Dodaj składnik
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <IngredientForCouverture v-for="rwTypeGroup in form.rawMaterialTypeGroup" :key="rwTypeGroup.id"
                  :rawMaterials="rawMaterials" :rawMaterialTypeGroup="rwTypeGroup" :counter="counter"
                  :recipeRef="$refs.recipe"></IngredientForCouverture>
              </div>
            </div>

            <div class="card mt-4">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <h4>Dodane kuwertury</h4>
                  </div>
                  <div class="col-4">
                    <button type="button" class="btn btn-primary float-right" @click="AddCouvertureItem">
                      Dodaj kuwerturę
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body" v-show="form.selectedCouvertures.length > 0">
                <AddExistingCouverture v-for="couverture in form.selectedCouvertures" :key="couverture.id"
                  :couverture="couverture" @AddExistingCouvertureRemoveItem="RemoveCouvertureItem">
                </AddExistingCouverture>
              </div>
            </div>

            <div class="card mt-4">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <h4>Przetopione produkty</h4>
                  </div>
                  <div class="col-4">
                    <button type="button" class="btn btn-primary float-right" @click="AddMeltDownProductItem">
                      Dodaj przetopiony produkt
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body" v-show="form.selectedMeltDownProducts.length > 0">
                <AddMeltDownProduct v-for="meltDownProductItem in form.selectedMeltDownProducts"
                  :key="meltDownProductItem.id" :meltDownProductItem="meltDownProductItem"
                  :availableMeltDownProducts="availableMeltDownProducts" @RemoveMeltDownProductItem="RemoveMeltDownProductItem">
                </AddMeltDownProduct>
              </div>
            </div>

            <div class="row">
              <div class="col align-self-end div-form-buttons-area">
                <button type="submit" class="btn-primary btn">Zapisz</button>
              </div>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import Loading from '../../components/Common/Loading';
import IngredientForCouverture from './IngredientForCouverture';
import DisplayRecepies from './DisplayRecepies';
import urlConfig from '../../mixins/url';
import toastr from '../../mixins/toastr';
import ProductionCommonMethods from '../../mixins/ProductionCommonMethods';
import axios from 'axios';
import AddExistingCouverture from './AddExistingCouverture';
import AddMeltDownProduct from './AddMeltDownProduct';
import CouvertureService from '../../services/couverture.service';
import RawMaterialService from '../../services/rawMaterial.service';

export default {
  name: 'EditCouverture',
  mixins: [urlConfig, toastr, ProductionCommonMethods],
  components: {
    Loading,
    IngredientForCouverture,
    DisplayRecepies,
    AddExistingCouverture,
    AddMeltDownProduct,
  },
  computed: {
    mills() {
      return this.$store.state.couvertureFormData.mills;
    },
    rawMaterialTypes() {
      return this.$store.state.couvertureFormData.rawMaterialTypes;
    },
    recipes() {
      return this.$store.state.couvertureFormData.recipes;
    },
  },
  mounted() {
    this.$store.dispatch('getCuvertureFormData');
    this.GetAvaiableRawMaterials();
    this.GetAvailableMeltDownProducts();
    this.GetRequiredFormData();
  },
  data() {
    return {
      busy: false,
      counter: 0,
      isLoaded: false,
      rawMaterials: [],
      availableMeltDownProducts: [],
      form: {
        rawMaterialTypeGroup: [],
        selectedCouvertures: [],
        selectedMeltDownProducts: [],
        millId: 0,
      },
    };
  },
  methods: {
    SetRecipe(recipe) {
      this.$refs.recipe.selectedRecipe = recipe;
    },
    SetCouvertureName(couvertureDetials) {
      this.form.name = couvertureDetials.name;
    },
    GetRawMaterialType(rawMaterilTypeId) {
      return this.rawMaterialTypes.filter((x) => x.id == rawMaterilTypeId)[0];
    },
    GetRawMaterialTypesFromRecipeAndCouverture(couvertureDetials, recipe) {
      var rawMaterialTypesInActualCuverture = couvertureDetials.indigrients.map((x) => x.rawMaterialTypeId);
      var rawMaterialTypesInRecipe = recipe.ingredients.map((x) => x.rawMaterialTypeId);

      var tmpRawMaterialTypes = rawMaterialTypesInActualCuverture.concat(rawMaterialTypesInRecipe);
      var rawMaterialTypes = tmpRawMaterialTypes.filter((item, pos) => tmpRawMaterialTypes.indexOf(item) === pos);

      return rawMaterialTypes;
    },
    GetRequiredFormData() {
      var that = this;
      var couvertureId = parseInt(this.$route.params.couvertureId);
      CouvertureService.getCouvertureDetailsById(couvertureId)
        .then((res) => {
          var couvertureDetials = res.data;
          this.form.millId = couvertureDetials.millId;

          var recipe = this.recipes.filter((x) => x.id == couvertureDetials.recipeId)[0];
          this.SetRecipe(recipe);
          this.SetCouvertureName(couvertureDetials);

          var rawMaterialTypes = that.GetRawMaterialTypesFromRecipeAndCouverture(couvertureDetials, recipe).filter(x => x != undefined);

          rawMaterialTypes.forEach((rawMaterialTypeId) => {
            var rawMaterialType = that.GetRawMaterialType(rawMaterialTypeId);
            var ingridients = couvertureDetials.indigrients
              .filter((x) => x.rawMaterialTypeId == rawMaterialTypeId)
              .map((x) => ({
                fullName: x.rawMaterialName + ' (seria: ' + x.batchNumber + ' )',
                id: x.rawMaterialId,
                availableWeight: (x.deliveryWeight - x.totalWeightInOtherCouvertures - x.usedWeight).toFixed(3),
                serialNumber: x.serialNumber,
                rawMaterialTypeId: x.rawMaterialTypeId,
                maxWeightToUse: x.deliveryWeight - x.totalWeightInOtherCouvertures,
                usedWeight: x.usedWeight,
              }));

            var rawMaterialGroupItem = {
              rawMaterialType: rawMaterialType,
              rawMaterials: [],
            };

            ingridients.forEach((item) => {
              var obj = {
                selectedRawMaterial: item,
                id: that.counter,
                usedWeight: item.usedWeight,
              };
              rawMaterialGroupItem.rawMaterials.push(obj);
              that.counter = this.counter + 1;
            });
            this.form.rawMaterialTypeGroup.push(rawMaterialGroupItem);
          });
          this.isLoaded = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    GetAvaiableRawMaterials() {
      var that = this;
      RawMaterialService.getAvaiableRawMaterials()
        .then(function (res) {
          that.rawMaterials = that.CreateAvaiableRawMaterialList(res);
        })
        .catch(function (err) {
          console.log(err);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage('Wystąpił błąd aplikacji!', err);
          that.isLoaded = false;
        });
    },
    SubmitForm(evt) {
      var rawMaterialsToAdd = [];

      evt.preventDefault();
      var isValid = this.FormValidation();
      var that = this;
      if (isValid) {
        this.busy = true;
        var rawMaterialGroups = this.form.rawMaterialTypeGroup.filter((x) => x.rawMaterialType.id != 0);

        rawMaterialGroups.forEach((rwg) => {
          rwg.rawMaterials.forEach((rw) => {
            if (rw.selectedRawMaterial.id) {
              rawMaterialsToAdd.push({
                rawMaterialId: rw.selectedRawMaterial.id,
                usedWeight: parseFloat(rw.usedWeight),
              });
            }
          });
        });

        var couvertures = this.form.selectedCouvertures
          .filter((x) => x.couverture)
          .map((x) => ({
            couvertureId: x.couverture.id,
            weight: x.weight,
          }));

        var meltDownProducts = this.form.selectedMeltDownProducts
          .filter((x) => x.meltDownProduct && x.meltDownProduct.id)
          .map((x) => ({
            meltDownProductId: x.meltDownProduct.id,
            weightToUse: x.weight,
          }));

        var couvertureId = parseInt(this.$route.params.couvertureId);
        axios
          .post(this.url.serverUrl + this.url.Couverture.EditCouverture, {
            couvertureId: couvertureId,
            millId: that.form.millId,
            name: that.$refs.recipe.selectedRecipe.name,
            indigrients: rawMaterialsToAdd,
            recipeId: that.$refs.recipe.selectedRecipe.id,
            couvertures: couvertures,
            meltDownProducts: meltDownProducts,
          })
          .then(function () {
            that.DisplaySuccess('Sukces!', 'Kuwertura została edytowana');
            window.location.href = '/#/Mlyny/';
          })
          .catch(function (e) {
            that.busy = false;
            console.log(e);
          });
      }
    },

    ValidateWeightForRawMaterials() {
      var groups = this.form.rawMaterialTypeGroup;
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var rawMaterials = group.rawMaterials;

        for (var j = 0; j < rawMaterials.length; j++) {
          var rawMaterialRow = rawMaterials[j];
          var avaiableWeight = rawMaterialRow.selectedRawMaterial.maxWeightToUse
            ? rawMaterialRow.selectedRawMaterial.maxWeightToUse
            : rawMaterialRow.selectedRawMaterial.avaiableWeight;
          var usedWeight = parseFloat(rawMaterialRow.usedWeight);

          if (usedWeight === undefined && rawMaterialRow.selectedRawMaterial.id) {
            this.DisplayError('Bład w produkcie', 'Brak wagi w produkcie ' + rawMaterialRow.selectedRawMaterial.name);
            return false;
          }

          if (usedWeight && (usedWeight < 0 || usedWeight > avaiableWeight)) {
            this.DisplayError('Bład w produkcie', 'Wpisana waga w produkcie ' + rawMaterialRow.selectedRawMaterial.name + ' jest nie prawidłowa');
            return false;
          }
        }
      }
      return true;
    },

    ValidateWeightForCouverture() {
      var couvertures = this.form.selectedCouvertures;
      for (var i = 0; i < couvertures.length; i++) {
        var couverutreRow = couvertures[i];
        var avaiableWeight = couverutreRow.couverture.totalWeight;
        var usedWeight = couverutreRow.weight;

        if (!usedWeight || usedWeight < 0 || usedWeight > avaiableWeight) {
          this.DisplayError('Bład w kuwerturze', 'Wpisana waga kuwertury ' + couverutreRow.couverture.name + ' jest nie prawidłowa.');
          return false;
        }
      }
      return true;
    },

    FormValidation() {
      var rawMaterialsWeight = this.ValidateWeightForRawMaterials();
      var couverturesWeight = this.ValidateWeightForCouverture();

      return rawMaterialsWeight == true && couverturesWeight == true;
    },

    AddNextPositionToCouvertureGroupList() {
      var rawMaterial = {
        id: this.counter,
        selectedRawMaterial: {
          id: 0,
          name: '',
          availableWeight: '',
          serialNumber: '',
        },
        usedWeight: 0,
      };
      this.form.rawMaterialTypeGroup.push({
        rawMaterialType: {},
        rawMaterials: [rawMaterial],
        id: this.counter,
      });
      this.counter = this.counter + 1;
    },
    AddCouvertureItem() {
      var couverture = this.CreateCouverture();
      couverture.id = this.counter;
      this.counter = this.counter + 1;
      this.form.selectedCouvertures.push(couverture);
    },
    RemoveCouvertureItem(couvertureId) {
      this.form.selectedCouvertures = this.form.selectedCouvertures.filter((x) => x.id != couvertureId);
    },
    GetAvailableMeltDownProducts() {
      var that = this;
      CouvertureService.getAvailableMeltDownProducts()
        .then(function (res) {
          that.availableMeltDownProducts = res.data.map((x) => ({
            ...x,
            displayName: `${x.productName} (${x.serialNumber}) - ${x.availableWeight} kg`,
          }));
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    AddMeltDownProductItem() {
      var meltDownProduct = {
        id: this.counter,
        meltDownProduct: null,
        weight: 0,
      };
      this.counter = this.counter + 1;
      this.form.selectedMeltDownProducts.push(meltDownProduct);
    },
    RemoveMeltDownProductItem(meltDownProductId) {
      this.form.selectedMeltDownProducts = this.form.selectedMeltDownProducts.filter((x) => x.id != meltDownProductId);
    },
  },
};
</script>
